import React from 'react';
import { Select } from '@chakra-ui/react';
import { useCurrentEvent } from '../context/CurrentEventContext';

// EventSwitcher
// --------------
// Renders a simple <select> allowing the user to switch between events
// if (and only if) they are registered for more than one.
// The selected event is persisted by CurrentEventContext, so it is
// remembered across page reloads.
const EventSwitcher = ({ size = 'sm' }) => {
  const { events, currentEvent, setCurrentEvent } = useCurrentEvent();

  // Only show if the user has multiple events
  if (!events || events.length <= 1) return null;

  const handleChange = (e) => {
    const id = e.target.value;
    const match = events.find((ev) => ev.id === id);
    if (match) setCurrentEvent(match);
  };

  return (
    <Select
      value={currentEvent?.id || ''}
      onChange={handleChange}
      size={size}
      width="auto"
      minW="150px"
      background="white"
      borderColor="gray.300"
      fontSize="sm"
    >
      {events.map((ev) => (
        <option key={ev.id} value={ev.id}>
          {ev.name}
        </option>
      ))}
    </Select>
  );
};

export default EventSwitcher; 